import {EventOptions, EventSchema} from './analytics.types';
import {initAndGetAnalyticsSdk} from '@mmt/event-logger';

class AnalyticsService {
  private static instance: AnalyticsService;
  private AnalyticsSdk: any;

  private init() {
    this.AnalyticsSdk = initAndGetAnalyticsSdk({
      org: 'MMT',
      // runtimeContextProvider: customRuntimeContextProvider,
      // networkClient: customNetworkClient,
    });
  }

  private constructor() {
    this.init();
  }

  static getInstance() {
    if (!AnalyticsService.instance) {
      AnalyticsService.instance = new AnalyticsService();
    }
    return AnalyticsService.instance;
  }

  /**
   * Track event in PDT
   * @param event - Event object following PDT schema
   * @param extraOptions - Additional context for Adobe Analytics
   */
  trackPDT(event: EventSchema, extraOptions: Partial<EventOptions> = {}): void {
    try {
      this.AnalyticsSdk.pushToPDT(event, extraOptions);
    } catch (error) {
      console.error('Error tracking PDT event:', error);
    }
  }

  /**
   * Track event in Adobe Data Layer
   * @param event - Event object following PDT schema
   * @param extraOptions - Additional context for Adobe Analytics
   */
  trackAdobe(event: EventSchema, extraOptions: Partial<EventOptions> = {}): void {
    try {
      this.AnalyticsSdk.pushToAdobeDataLayer(event, extraOptions);
    } catch (error) {
      console.error('Error tracking Adobe event:', error);
    }
  }

  /**
   * Track event in both PDT and Adobe Data Layer
   * @param event - Event object following PDT schema
   * @param extraOptions - Additional context for Adobe Analytics
   */
  trackAll(event: EventSchema, extraOptions: Partial<EventOptions> = {}): void {
    try {
      this.AnalyticsSdk.pushToAll(event, extraOptions);
    } catch (error) {
      console.error('Error tracking event:', error);
    }
  }

  /**
   * Helper method to create common event options
   * @param lob - Line of business
   * @param destinationUrl - URL involved in the event
   * @returns Common event options
   */
  static createEventOptions(
    lob: string = 'common',
    destinationUrl: string = window.location.href,
  ): EventOptions {
    return {
      lob,
      destinationUrl,
    };
  }
}

export default AnalyticsService.getInstance();

// Export the provider components
export {AnalyticsServiceProvider, useAnalyticService} from './Provider';
